import Vue from 'vue'
import Vuex from 'vuex'

import router      from '@/router'

import login       from '@/modules/login'
import productos   from '@/modules/productos'
import tema        from '@/modules/tema'
import Carrito     from '@/modules/carrito';
import twilio      from '@/modules/twilio';

import createPersistedState  from  'vuex-persistedstate'

Vue.use(Vuex)

const VUEX_STORAGE_KEY = 'vuex'

/** El módulo twilio no se persiste: las listas de chats crecen y agotan la cuota de localStorage (~5MB). */
function estadoSinTwilio (state) {
  if (state == null || typeof state !== 'object' || Array.isArray(state)) return undefined
  const { twilio, ...rest } = state
  return rest
}

function getStateSinTwilio (key, storage) {
  try {
    const raw = storage.getItem(key)
    if (raw == null) return undefined
    const parsed = JSON.parse(raw)
    return estadoSinTwilio(parsed)
  } catch (e) {
    return undefined
  }
}

function setStateConRecuperacion (key, state, storage) {
  const payload = JSON.stringify(state)
  try {
    storage.setItem(key, payload)
  } catch (e) {
    const quota =
      e &&
      (e.name === 'QuotaExceededError' ||
        e.code === 22 ||
        (typeof DOMException !== 'undefined' && e instanceof DOMException && e.name === 'QuotaExceededError'))
    if (!quota) throw e
    try {
      storage.removeItem(key)
      storage.setItem(key, payload)
    } catch (e2) {
      try {
        storage.removeItem(key)
      } catch (e3) { /* ignore */ }
      console.warn('[vuex-persistedstate] Cuota de almacenamiento superada; no se guardó el estado.', e2)
    }
  }
}

const persistedStatePlugin = createPersistedState({
  key: VUEX_STORAGE_KEY,
  getState: getStateSinTwilio,
  reducer: (state) => estadoSinTwilio(state),
  setState: setStateConRecuperacion,
})

export default new Vuex.Store({
  state: {
    abrir_carrito: false,
    alerta: {
      mostrar: false,
      tipo: 'success', // o 'error', 'warning'
      mensaje: '',
    },
  },

  mutations: {
    ABRIR_CARRO(state, estado){
      state.abrir_carrito = estado
    },

    mostrarAlerta(state, payload) {
      state.alerta = {
        mostrar: true,
        tipo: payload.tipo,
        mensaje: payload.mensaje,
      };
    },
    
    cerrarAlerta(state) {
      state.alerta.mostrar = false;
    },
  },

  actions: {
    abrirCarrito({commit}, estado){
      commit('ABRIR_CARRO',estado)
    },
  },

  getters:{
    getStateCarrito(state){
      return state.abrir_carrito
    }
  },

	modules:{
		login,
    productos,
    tema,
    Carrito,
    twilio
	},

  plugins: [persistedStatePlugin],

})
